import React from 'react';

interface BookmarkTagsProps {
  bookmarkId: string;
  tags: string[];
  onAddTag: (bookmarkId: string) => void;
  onRemoveTag: (bookmarkId: string, tag: string) => void;
  onTagClick: (tag: string) => void;
}

export const BookmarkTags: React.FC<BookmarkTagsProps> = ({
  bookmarkId,
  tags,
  onAddTag,
  onRemoveTag,
  onTagClick
}) => {
  return (
    <div className="bookmark-tags">
      {tags.map(tag => (
        <span 
          key={tag} 
          className="bookmark-tag removable"
          onClick={() => onTagClick(tag)}
        >
          {tag}
          <button
            className="tag-remove-btn"
            onClick={(e) => {
              e.stopPropagation();
              onRemoveTag(bookmarkId, tag);
            }}
            title={`Remove ${tag} tag`}
          >
            <span role="img" aria-label="remove tag">×</span>
          </button>
        </span>
      ))}
      <button
        className="bookmark-add-tag-btn"
        onClick={() => onAddTag(bookmarkId)}
        title="Add new tag"
      >
        <span role="img" aria-label="add tag">+</span>
      </button>
    </div>
  );
};